import { api } from './api'
import { endpoints } from './endpoints'

export { endpoints }
export default api
